import { Injectable } from '@angular/core'
import { environment } from '@employer/environments/environment'
import { RestApiClient } from '@engineering11/web-api-rest'
import { map, Observable, of } from 'rxjs'

/**
 * Public exchange of a short-lived "act-as" code (minted by the admin app's
 * impersonation flow, Story 1.2) for a Firebase custom token. Called before
 * the employer app has any signed-in user, so this client is unauthenticated
 * (`token: of(null)`) — mirrors `CandidatePoolShareService`'s public client.
 */
@Injectable({ providedIn: 'root' })
export class ImpersonationExchangeService {
  private api = new RestApiClient({
    baseUrl: environment.services.platformAdmin,
    token: of(null),
  })

  exchange(code: string): Observable<{ token: string }> {
    return this.api.post<{ token: string }>('impersonation/exchange', { code }).pipe(map(res => res.data))
  }
}
